export default __webpack_public_path__ + "static/media/86.cdd97596.gif";